module.exports = __webpack_public_path__ + "assets/img/ecg-detail-back-banner3.3e51d6b7.png";